import {Component, OnInit, Inject, ElementRef} from "@angular/core";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from "@angular/material";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {
  CommonService,
  AlertService,
  AdminService,
  LeadService,
} from "../../_services/";
import {ToastrService} from "ngx-toastr";

import * as firebase from "firebase/app"; // Typescript
// import firebase from 'firebase/app'; // JS
import "firebase/functions";
import {environment} from "../../../environments/environment";
import {Subscription} from "rxjs";

@Component({
  selector: "app-add-appointment-dialog",
  templateUrl: "./add-appointment-dialog.component.html",
  styleUrls: ["./add-appointment-dialog.component.scss"],
})
export class AddAppointmentDialogComponent implements OnInit {
  addAppointmentForm: FormGroup;
  submitted: Boolean = false;
  hour12Timer: Boolean = true;
  calenderEventTypeList: any[] = [];
  locations: any;
  errMsg: String;
  addressGoogleObject = {};
  defaultLocation: "";
  showroomList: any;
  private subscription: Subscription;
  private subscription2: Subscription;
  private subscription3: Subscription;
  constructor(
    public dialogRef: MatDialogRef<AddAppointmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private _common: CommonService,
    private _alert: AlertService,
    private _admin: AdminService,
    private _lead: LeadService,
    private _toastr: ToastrService
  ) {}

  ngOnInit() {
    this.addAppointmentForm = this.formBuilder.group({
      appointment_date_time: [null, []],
      calendar_event_type_id: [null, [Validators.required]],
      address: [null, []],
      showroom_id: [null, []],
    });
    this.getCalenderEventTypeList();
    this.getShowroomList();
    if (firebase.apps.length < 2) {
      const app = firebase.initializeApp(environment.firebaseConfig);
      if (window.location.host.includes("localhost")) {
        app.functions().useFunctionsEmulator("http://localhost:5000");
      }
    }
  }

  onClick(event) {
    const divSec = (<Element>event.target).className;
    if (!divSec.includes("location-area"))
      // or some similar check
      this.locations = [];
  }

  setLocation(location) {
    this.subscription3.unsubscribe();
    this.addAppointmentForm.patchValue({address: location.description});
    this.addressGoogleObject = location;
    this.locations = [];
  }

  getShowroomList() {
    this.subscription = this._admin.geShowroomList().subscribe(
      (res) => {
        this.showroomList = res;
      },
      (error) => {
        this.errMsg = error.error.message
          ? error.error.message
          : "Something went wrong!";
      }
    );
  }

  isVisible(typeVar) {
    if (this.defaultLocation === typeVar) {
      return true;
    } else {
      return false;
    }
  }

  changeLocation(type) {
    const showroomControl = this.addAppointmentForm.get("showroom_id");
    const addressControl = this.addAppointmentForm.get("address");
    if (type === "showroom") {
      showroomControl.setValidators([Validators.required]);
      addressControl.setValidators(null);
    } else {
      addressControl.setValidators([Validators.required]);
      showroomControl.setValidators(null);
    }

    this.defaultLocation = type;
  }

  // Get calendar event types...
  getCalenderEventTypeList() {
    this._common.showLoader(true);
    this.subscription2 = this._admin.getCalenderEventTypeList().subscribe(
      (result) => {
        this._common.showLoader(false);
        this.calenderEventTypeList = result;
      },
      (err) => {
        this._common.showLoader(false);
        this._alert.error(
          err.error.message ? err.error.message : "Something went wrong!"
        );
      }
    );
  }

  getSuggestions(event) {
    this.subscription3 = this._admin
      .getSuggestions(event.target.value)
      .subscribe(
        (res) => {
          this.locations = res["data"];
        },
        (err) => {
          this._common.showLoader(false);
          this.errMsg = err.message;
        }
      );
  }

  hideAddAppointmentDialog() {
    this.dialogRef.close();
  }

  get fval() {
    return this.addAppointmentForm.controls;
  }

  onFormSubmit() {
    this.submitted = true;
    if (this.addAppointmentForm.invalid) {
      return;
    }
    let form = this.addAppointmentForm.value;
    form.uid = localStorage.getItem("uid");
    form.address_google = JSON.stringify(this.addressGoogleObject);
    form.start_date_time = new Date(form.appointment_date_time).getTime(); //JSON.stringify(form.appointment_date_time);
    form.end_date_time = new Date(form.appointment_date_time).getTime(); // JSON.stringify(form.appointment_date_time);
    // form.appointment_date_time = new Date(form.appointment_date_time).getTime();
    form.contact_id = this.data.contact_id ? this.data.contact_id : null;
    form.project_id = this.data.project_id ? this.data.project_id : null;
    // form.category = this.data.category;
    form.date_created = new Date().getTime();
    this._common.showLoader(true);
    var functions = firebase.functions();
    let createCalendarEvent = firebase
      .functions()
      .httpsCallable("create_calendar_event");
    createCalendarEvent(form).then(
      (result) => {
        this._common.showLoader(false);
        this.dialogRef.close();
        this._toastr.success(`Appointment created successfully!`, "", {
          timeOut: 4000,
        });
      },
      (err) => {
        this._common.showLoader(false);
        this._toastr.error(
          `${
            err && err.error && err.error.message
              ? err.error.message
              : "Something went wrong!"
          }`,
          "",
          {timeOut: 4000}
        );
      }
    );
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.subscription2) this.subscription2.unsubscribe();
    if (this.subscription3) this.subscription3.unsubscribe();
  }
}
